<script lang="ts">
    import { getCachedEntries } from "../api"
    import { getUserCountry } from "../lib/utils"

    export let formData: CartFormData = {
        contact: {
            firstName: "",
            lastName: "",
            email: "",
            emailOptIn: false,
        },
        shippingAddress: {
            firstName: "",
            lastName: "",
            organisation: "",
            address1: "",
            address2: "",
            zip: "",
            city: "",
            state: "",
            countryCode: getUserCountry(),
            phoneNumber: "",
        },
        billingAddress: {
            sameAsShipping: true,
            firstName: "",
            lastName: "",
            organisation: "",
            address1: "",
            address2: "",
            zip: "",
            city: "",
            state: "",
            countryCode: getUserCountry(),
            phoneNumber: "",
        },
    }

    let nameInFocus = false
    // read form data from session storage
    if (typeof window !== "undefined") {
        let storedFormData = JSON.parse(sessionStorage.getItem("cartFormData"))
        if (storedFormData) {
            formData = storedFormData
        }
        // check if contact firstName or lastName differ from shippingAddress
        if (
            formData.contact.firstName !== formData.shippingAddress.firstName ||
            formData.contact.lastName !== formData.shippingAddress.lastName
        ) {
            // emulate focus on name fields
            nameInFocus = true
        }
    }

    // store form data in session storage
    $: if (typeof window !== "undefined") {
        sessionStorage.setItem("cartFormData", JSON.stringify(formData))
    }

    export let submitHandler = async () => {
        // Form submission logic here
        console.log("Form submitted", formData)
    }

    export let submitDisabled = false
    let accepted = false

    $: if (!formData.billingAddress.sameAsShipping) {
        if (!formData.billingAddress.firstName && !formData.billingAddress.lastName) {
            formData.billingAddress.firstName = formData.shippingAddress.firstName
            formData.billingAddress.lastName = formData.shippingAddress.lastName
        }
    }

    // copy contact fistName and lastName to shippingAddress if not in focus
    $: if (!nameInFocus) {
        formData.shippingAddress.firstName = formData.contact.firstName
        formData.shippingAddress.lastName = formData.contact.lastName
    }
</script>

<div class="container tp-xxl bp-xxl">
    <form on:submit|preventDefault="{submitHandler}">
        <h2>Contact</h2>
        <div class="grid tp-l">
            <div class="col-md-6 col-grid border-bottom">
                <label for="contactFirstName">First Name *</label>
                <input id="contactFirstName" type="text" bind:value="{formData.contact.firstName}" required />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="contactLastName">Last Name *</label>
                <input id="contactLastName" type="text" bind:value="{formData.contact.lastName}" required />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="contactEmail">Email *</label>
                <input id="contactEmail" type="email" bind:value="{formData.contact.email}" required />
            </div>
            <div class="col-12">
                <input type="checkbox" id="optInNewsletter" bind:checked="{formData.contact.emailOptIn}" />
                <label class="checkbox-wrap" for="optInNewsletter"
                    ><span
                        >Subscribe to the SPORTident Newsletter to learn about new products, interesting sports events,
                        and special offers.</span
                    ></label
                >
            </div>
            <div class="col-12 container tp-l bp-l">
                <h2>Shipping Address</h2>
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingFirstName">First Name *</label>
                <input
                    id="shippingFirstName"
                    type="text"
                    bind:value="{formData.shippingAddress.firstName}"
                    required
                    on:focus="{() => (nameInFocus = true)}"
                />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingLastName">Last Name *</label>
                <input
                    id="shippingLastName"
                    type="text"
                    bind:value="{formData.shippingAddress.lastName}"
                    required
                    on:focus="{() => (nameInFocus = true)}"
                />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingCompany">Company / Club</label>
                <input id="shippingCompany" type="text" bind:value="{formData.shippingAddress.organisation}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingAddress">Address *</label>
                <input id="shippingAddress" type="text" bind:value="{formData.shippingAddress.address1}" required />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingAdditionalAddress">Additional Address</label>
                <input id="shippingAdditionalAddress" type="text" bind:value="{formData.shippingAddress.address2}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingPostalCode">Postal Code *</label>
                <input id="shippingPostalCode" type="text" bind:value="{formData.shippingAddress.zip}" required />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingCity">City *</label>
                <input id="shippingCity" type="text" bind:value="{formData.shippingAddress.city}" required />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingState">State / Region</label>
                <input id="shippingState" type="text" bind:value="{formData.shippingAddress.state}" />
            </div>
            <div class="col-md-6 col-grid border-bottom">
                <label for="shippingCountry">Country *</label>
                {#if typeof window !== "undefined"}
                    {#await getCachedEntries("country", null, "name") then countries}
                        <select id="shippingCountry" bind:value="{formData.shippingAddress.countryCode}" required>
                            <option value="" selected disabled>Please select...</option>
                            {#each countries as country}
                                <option value="{country.code}">{country.name}</option>
                            {/each}
                        </select>
                    {/await}
                {/if}
            </div>

            <div class="col-12 container tp-l bp-l">
                <h2>Billing Address</h2>
            </div>

            <div class="col-12">
                <input
                    id="billingSameAsShipping"
                    type="checkbox"
                    bind:checked="{formData.billingAddress.sameAsShipping}"
                />
                <label class="checkbox-wrap" for="billingSameAsShipping"><span>Same as Shipping Address</span></label>
            </div>

            {#if !formData.billingAddress.sameAsShipping}
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingFirstName">First Name *</label>
                    <input
                        id="billingFirstName"
                        type="text"
                        bind:value="{formData.billingAddress.firstName}"
                        required
                    />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingLastName">Last Name *</label>
                    <input id="billingLastName" type="text" bind:value="{formData.billingAddress.lastName}" required />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingCompany">Company / Club</label>
                    <input id="billingCompany" type="text" bind:value="{formData.billingAddress.organisation}" />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingAddress">Address *</label>
                    <input id="billingAddress" type="text" bind:value="{formData.billingAddress.address1}" required />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingAdditionalAddress">Additional Address</label>
                    <input id="billingAdditionalAddress" type="text" bind:value="{formData.billingAddress.address2}" />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingPostalCode">Postal Code *</label>
                    <input id="billingPostalCode" type="text" bind:value="{formData.billingAddress.zip}" required />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingCity">City *</label>
                    <input id="billingCity" type="text" bind:value="{formData.billingAddress.city}" required />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingState">State / Region</label>
                    <input id="billingState" type="text" bind:value="{formData.billingAddress.state}" />
                </div>
                <div class="col-md-6 col-grid border-bottom">
                    <label for="billingCountry">Country *</label>
                    {#if typeof window !== "undefined"}
                        {#await getCachedEntries("country", null, "name") then countries}
                            <select id="billingCountry" bind:value="{formData.billingAddress.countryCode}" required>
                                <option value="" selected disabled>Please select...</option>
                                {#each countries as country}
                                    <option value="{country.code}">{country.name}</option>
                                {/each}
                            </select>
                        {/await}
                    {/if}
                </div>
            {/if}
        </div>
        <div class="grid align-center">
            <div class="col-auto privacy">
                <input type="checkbox" id="privacy" required bind:checked="{accepted}" />
                <label class="checkbox-wrap" for="privacy"
                    ><span>Accept <a href="/legal-information" target="_blank">Privacy Policy</a></span></label
                >
            </div>
            <div class="col-auto align-self-end">
                <div class="bp-m">After you submit the form, we will send you an offer via email.</div>
                <button disabled="{submitDisabled || !accepted}" type="submit" class="btn-primary"
                    >Request an offer</button
                >
            </div>
        </div>
    </form>
</div>

<style lang="less">
    button:disabled {
        opacity: 0.5;
    }
</style>
